const state = {
  isCollapse: false,
  devId: '',
  devIds: [],
  clickedStep: '',
  progId: '',
  currentStep: '',
  funcData: '',
  // 曲线图下边按钮使用
  mainFuncData: [],
  paraFuncData: [],
  stepTimeRecords: [],
  mixMainNTimes: '',
  stepTimes: '',
  deviceDetails: '',
  clickedDev: '',
  // 主功能使用
  mainFunc: [],
  // 数据监控
  dataMonitor: '',
  // 批次参考号码
  referenceNO: '',
  // 详情tag
  fromTag: '',
  // 页面是否有被点击
  clickedTag: false,
  // 标识点击的是主功能部分还是线图按钮部分
  clickedPos: 'on',
  lineClickedTag: '',
  chosenList: [],
  noSteps: '',
  ioTag: 'off',
  lasttimeless4: '',
  runningMode: '',
  idList: [],
  reqs: false,
  moretag: 'more',
  runningStatus: '',
  lockStatus: '',
  marklineTime: '',
  fromMsg: '',
  lines: '1, 2',
  operationTit: '',
  isNeedRef: false,
  deviceBrandId: '',
  batchRecords: ''
};

const mutations = {
  SET_COLLAPSE: (state, ic) => {
    state.isCollapse = ic;
  },
  SET_DEVID: (state, devId) => {
    state.devId = devId;
  },
  SET_DEVIDS: (state, devIds) => {
    state.devIds = devIds;
  },
  SET_CLICKEDSTEP: (state, step) => {
    state.clickedStep = step;
  },
  SET_PROGID: (state, progId) => {
    state.progId = progId;
  },
  SET_CURSTEP: (state, step) => {
    state.currentStep = step;
  },
  SET_FUNCDATA: (state, dt) => {
    state.funcData = dt;
  },
  SET_MAINFUNCDATA: (state, dt) => {
    state.mainFuncData = dt;
  },
  SET_PARAFUNCDATA: (state, dt) => {
    state.paraFuncData = dt;
  },
  SET_TIMERECORDS: (state, dt) => {
    state.stepTimeRecords = dt;
  },
  SET_MAINNTIME: (state, dt) => {
    state.mixMainNTimes = dt;
  },
  SET_STEPTIMES: (state, dt) => {
    state.stepTimes = dt;
  },
  SET_DEVICEDETAILS: (state, dt) => {
    state.deviceDetails = dt;
  },
  SET_CLICKEDDEV: (state, dt) => {
    state.clickedDev = dt;
  },
  SET_MAINFUNC: (state, dt) => {
    state.mainFunc = dt;
  },
  SET_DATAMONITOR: (state, dt) => {
    state.dataMonitor = dt;
  },
  SET_REFERENCENO: (state, dt) => {
    state.referenceNO = dt;
  },
  SET_TAG: (state, dt) => {
    state.fromTag = dt;
  },
  SET_CLICKEDPOS: (state, dt) => {
    state.clickedPos = dt;
  },
  SET_LINECLICKEDTAG: (state, dt) => {
    state.lineClickedTag = dt;
  },
  SET_CHOSENLIST: (state, dt) => {
    state.chosenList = dt;
  },
  SET_NOSTEPS: (state, st) => {
    state.noSteps = st;
  },
  SET_IOTAG: (state, st) => {
    state.ioTag = st;
  },
  SET_LASTLESS4: (state, st) => {
    state.lasttimeless4 = st;
  },
  SET_RUNNINGMODE: (state, st) => {
    state.runningMode = st;
  },
  SET_RUNNINGSTATUS: (state, st) => {
    state.runningStatus = st;
  },
  SET_LOCKSTATUS: (state, st) => {
    state.lockStatus = st;
  },
  SET_IDLIST: (state, idList) => {
    if (idList) {
      state.idList.push(idList);
    } else {
      state.idList = [];
    }
  },
  SET_REQS: (state, st) => {
    state.reqs = st;
  },
  SET_MORETAG: (state, mt) => {
    state.moretag = mt;
  },
  SET_CLICKEDTAG: (state, bol) => {
    state.clickedTag = bol;
  },
  SET_MARKLINETIME: (state, dt) => {
    state.marklineTime = dt;
  },
  SET_FROMMSG: (state, dt) => {
    state.fromMsg = dt;
  },
  SET_LINES: (state, dt) => {
    state.lines = dt;
  },
  SET_OPERS: (state, dt) => {
    state.operationTit = dt;
  },
  SET_ISNEEDREF: (state, dt) => {
    state.isNeedRef = dt;
  },
  SET_DEVICEBRANDID: (state, dt) => {
    state.deviceBrandId = dt;
  },
  SET_BATCHRECORDS: (state, dt) => {
    state.batchRecords = dt;
  }

};

const actions = {
  // 记录$t('更多')的展开收缩
  markdownCollapse({ commit }, info) {
    commit('SET_COLLAPSE', info);
  },
  // 记录devId
  markdownDevid({ commit }, info) {
    commit('SET_DEVID', info);
  },
  // 记录设备checkboxs弹窗传回的多个或单个devId
  markdownDevids({ commit }, info) {
    commit('SET_DEVIDS', info);
  },
  // 记录被点击的步骤
  markdownClickedStep({ commit }, info) {
    commit('SET_CLICKEDSTEP', info);
  },
  // 记录progId
  markdownProgid({ commit }, info) {
    commit('SET_PROGID', info);
  },
  // 记录当前步骤
  markdownCurrentStep({ commit }, info) {
    commit('SET_CURSTEP', info);
  },
  // 还没有拼接时间的主功能的数据
  markdownFuncData({ commit }, info) {
    commit('SET_FUNCDATA', info);
  },
  // 点击某个主功能对应的数据
  markdownMainFuncData({ commit }, info) {
    commit('SET_MAINFUNCDATA', info);
  },
  // 点击某个主功能对应的并行功能数据
  markdownParaFuncData({ commit }, info) {
    commit('SET_PARAFUNCDATA', info);
  },
  // 记录折线图下按钮时间数据
  markdownTimeRecords({ commit }, info) {
    commit('SET_TIMERECORDS', info);
  },
  // 保存有主功能数据且已拼接好时间的数据
  markdownMainTime({ commit }, info) {
    commit('SET_MAINNTIME', info);
  },
  // 记录点击的位置的开始时间和结束时间
  markdownStepTime({ commit }, info) {
    commit('SET_STEPTIMES', info);
  },
  // 保存该控制器的相关数据（用于顶部栏数据展示）
  markdownClickedDev({ commit }, info) {
    commit('SET_CLICKEDDEV', info);
  },
  // 保存io数据
  markdownDataMonitor({ commit }, info) {
    commit('SET_DATAMONITOR', info);
  },
  // 记录referenceNo
  markdownReferenceNo({ commit }, info) {
    commit('SET_REFERENCENO', info);
  },
  // 当前是单机监控还是历史记录
  markdownTag({ commit }, info) {
    commit('SET_TAG', info);
  },
  // 区分点击的是左侧主功能还是折线图下按钮
  markdownClickedPos({ commit }, info) {
    commit('SET_CLICKEDPOS', info);
  },
  // 保存当前点击的stepUid或index
  markdownLineClickedTag({ commit }, info) {
    commit('SET_LINECLICKEDTAG', info);
  },
  // 远程监控中已选择的设备
  markdownChosenList({ commit }, info) {
    commit('SET_CHOSENLIST', info);
  },
  // 保存当前曲线下没有步骤
  markdownNoSteps({ commit }, info) {
    console.log('commit', info);
    commit('SET_NOSTEPS', info);
  },
  // 是否刚进入页面且没有点击
  markdownIoTag({ commit }, info) {
    commit('SET_IOTAG', info);
  },
  // 判断接口返回的时间数据是否超过4小时
  markdownLastLess4({ commit }, info) {
    commit('SET_LASTLESS4', info);
  },
  // 当前设备的运行模式
  markdownRunningMode({ commit }, info) {
    commit('SET_RUNNINGMODE', info);
  },
  // 当前设备的运行状态
  markdownRunningStatus({ commit }, info) {
    commit('SET_RUNNINGSTATUS', info);
  },
  // 当前设备的锁定状态
  markdownLockStatus({ commit }, info) {
    commit('SET_LOCKSTATUS', info);
  },
  // getProdId、getRecordTimes、getProgDetails三个请求是否都执行完
  markdownReqs({ commit }, info) {
    commit('SET_REQS', info);
  },
  // “更多”展示的内容（可能是警报列表或“更多”的相关数据）
  markdownMoreTag({ commit }, info) {
    commit('SET_MORETAG', info);
  },
  // 页面是否曾经点击过左侧主功能或折线图下面的按钮
  markdownClickedTag({ commit }, info) {
    commit('SET_CLICKEDTAG', info);
  },
  // 点击折线图时箭头虚线标记的位置（时间）
  markdownMarklineTime({ commit }, info) {
    commit('SET_MARKLINETIME', info);
  },
  // 是否从“消息页面”跳转到当前监控页面
  fromMsg({ commit }, info) {
    commit('SET_FROMMSG', info);
  },
  // $t('设置')展示什么曲线
  markdownLines({ commit }, info) {
    commit('SET_LINES', info);
  },
  markdownOpers({ commit }, info) {
    commit('SET_OPERS', info);
  },
  markdownNeedRef({ commit }, info) {
    commit('SET_ISNEEDREF', info);
  },
  markdownDeviceBrandId({ commit }, info) {
    commit('SET_DEVICEBRANDID', info);
  },
  markdownBatchRecords({ commit }, info) {
    commit('SET_BATCHRECORDS', info);
  }
  // user login
  //   login({ commit }, userInfo) {
  //     const { user_id, password } = userInfo
  //     return new Promise((resolve, reject) => {
  //       const params = { user_id: parseInt(user_id), password: password }
  //       login(params).then(response => {
  //         // console.log('res', response)
  //         const { data } = response
  //         // console.log('dt', data.accessToken)
  //         localStorage.setItem($t('token'), data.accessToken)
  //         localStorage.setItem('refreshToken', data.refreshToken)
  //         commit('SET_TOKEN', data.accessToken)
  //         commit('SET_USERID', user_id)
  //         setToken(data.refreshToken)
  //         resolve()
  //       }).catch(error => {
  //         console.log('error', error)
  //         // reject(error)
  //       })
  //     })
  //   },

  //   // get user info
  //   getInfo({ commit, state }) {
  //     return new Promise((resolve, reject) => {
  //       getInfo(parseInt(state.userId)).then(response => {
  //         const { data, code } = response

  //         if (code !== 1) {
  //           reject($t('验证失败,请重新登录'))
  //         }

  //         // const { name, avatar, introduction } = data
  //         // const { user_id, role_id } = data

  //         // 暂时进入系统需要用到，正式版关闭
  //         const roles = ['admin']

  //         // roles must be a non-empty array
  //         // if (!roles || roles.length <= 0) {
  //         //   reject('getInfo: roles must be a non-null array!')
  //         // }

  //         // 暂时进入系统需要用到，正式版关闭
  //         commit('SET_ROLES', roles)
  //         // commit('SET_NAME', user_id)
  //         // commit('SET_ROLEID', role_id)

  //         const finalData = {
  //           ...data,
  //           roles
  //         }
  //         // commit('SET_AVATAR', avatar)
  //         // commit('SET_INTRODUCTION', introduction)
  //         resolve(finalData)
  //       }).catch(error => {
  //         reject(error)
  //       })
  //     })
  //   },

  //   // 获取权限列表
  //   getAuth({ commit, state }) {
  //     return new Promise((resolve, reject) => {
  //       getAuthAll(parseInt(state.roleId)).then(response => {
  //         const { data } = response

  //         if (!data) {
  //           reject($t('获取权限失败'))
  //         }
  //         commit('SET_AUTH', data)
  //         resolve(data)
  //       }).catch(error => {
  //         reject(error)
  //       })
  //     })
  //   },

  //   // user logout
  //   logout({ commit, state, dispatch }) {
  //     return new Promise((resolve, reject) => {
  //       logout(state.token).then(() => {
  //         removeToken()
  //         resetRouter()

  //         // reset visited views and cached views
  //         // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
  //         dispatch('tagsView/delAllViews', null, { root: true })

  //         resolve()
  //       }).catch(error => {
  //         reject(error)
  //       })
  //     })
  //   },

  //   // remove token
  //   resetToken({ commit }) {
  //     return new Promise(resolve => {
  //       commit('SET_TOKEN', '')
  //       commit('SET_ROLES', [])
  //       commit('SET_AUTH', [])
  //       localStorage.removeItem($t('token'))
  //       localStorage.removeItem('refreshToken')
  //       removeToken()
  //       resolve()
  //     })
  //   },

  //   // dynamically modify permissions
  //   async changeRoles({ commit, dispatch }, role) {
  //     const token = role + '-token'

  //     commit('SET_TOKEN', token)
  //     setToken(token)

  //     const { roles } = await dispatch('getInfo')

  //     resetRouter()

  //     // generate accessible routes map based on roles
  //     const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })
  //     // dynamically add accessible routes
  //     router.addRoutes(accessRoutes)

//     // reset visited views and cached views
//     dispatch('tagsView/delAllViews', null, { root: true })
//   }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
